module.exports = __webpack_public_path__ + "media/images/icons/academic-development-759d5f23f2bb8d7ba43e884349b30402.svg";